// Single source of truth for the website's runtime config. Every value comes
// from a VITE_ variable that Vite injects at build time from the .env file
// matching the build MODE — no values are hardcoded here anymore:
//   vite dev                  → .env.development (per-clone localhost URLs, test Stripe)
//   vite build                → .env            (live Stripe, prod URLs)
//   vite build --mode staging → .env.staging    (test Stripe, staging URLs)
export const ENVIRONMENT = {
  STRIPE_PUBLIC_KEY: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  WEBSITE_URL: import.meta.env.VITE_WEBSITE_URL,
  SERVER_URL: import.meta.env.VITE_SERVER_URL,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  GOOGLE_MAPS: import.meta.env.VITE_GOOGLE_MAPS,
  // Immutable, content-addressed screencast CDN (screencasts.<domain>). Derived
  // from the domain by `cam sync-deploy-env render`, like the other URLs.
  SCREENCAST_CDN_URL: import.meta.env.VITE_SCREENCAST_CDN_URL,
}
